import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  INSTALLATIONS: 'installations',
  ENTITIES: 'entities',
  INFORMATION_PATH: 'information',
  CONFIGURATION_PATHS: {
    CONFIGURATION: 'configuration',
    DOORS: 'doors',
    SOURCES: 'sources',
    DEVICES_PATHS: {
      DEVICES: 'devices',
      SLAVES: 'slaves',
    },
  },
  SCENARIOS: 'scenarios',
  CUSTOMERS: 'customers',
  PLANNINGS: 'plannings',
  LOGS: 'logs',
  ASYNC_OPERATIONS: 'asyncOperations',
};

// Exported paths
export const MAIN_PATH = PATHS.INSTALLATIONS;
export const ENTITIES_PATH = PATHS.ENTITIES;
export const { INFORMATION_PATH } = PATHS;
export const CONFIGURATION_PATH = PATHS.CONFIGURATION_PATHS.CONFIGURATION;
export const CONFIGURATION_DOORS_PATH = PATHS.CONFIGURATION_PATHS.DOORS;
export const CONFIGURATION_SOURCES_PATH = PATHS.CONFIGURATION_PATHS.SOURCES;
export const CONFIGURATION_DEVICES_PATH = PATHS.CONFIGURATION_PATHS.DEVICES_PATHS.DEVICES;
export const CONFIGURATION_DEVICES_SLAVES_PATH = PATHS.CONFIGURATION_PATHS.DEVICES_PATHS.SLAVES;
export const SCENARIOS_PATH = PATHS.SCENARIOS;
export const CUSTOMERS_PATH = PATHS.CUSTOMERS;
export const PLANNINGS_PATH = PATHS.PLANNINGS;
export const LOGS_PATH = PATHS.LOGS;
export const ASYNC_OPERATIONS_PATH = PATHS.ASYNC_OPERATIONS;

// Root
const APP_INSTALLATIONS_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_INSTALLATIONS_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const addPath = () => `${APP_INSTALLATIONS_PATH}/add`;
export const navigateToAdd = () => {
  hashHistory.push(addPath());
};

export const showPath = (id) => `${APP_INSTALLATIONS_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};

// Configuration
export const configurationPath = (id) => `${showPath(id)}/${CONFIGURATION_PATH}`;
export const navigateToConfiguration = (id) => {
  hashHistory.push(configurationPath(id));
};
export const configurationDoorsAddPath = (id) => `${configurationPath(id)}/${CONFIGURATION_DOORS_PATH}/add`;
export const navigateToConfigurationDoorsAdd = (id) => {
  hashHistory.push(configurationDoorsAddPath(id));
};
export const configurationDoorsShowPath = (id, idDoor) => `${configurationPath(id)}/${CONFIGURATION_DOORS_PATH}/${idDoor}`;
export const navigateToConfigurationDoorsShow = (id, idDoor) => {
  hashHistory.push(configurationDoorsShowPath(id, idDoor));
};
export const configurationSourcesAddPath = (id) => `${configurationPath(id)}/${CONFIGURATION_SOURCES_PATH}/add`;
export const navigateToConfigurationSourcesAdd = (id) => {
  hashHistory.push(configurationSourcesAddPath(id));
};
export const configurationSourcesShowPath = (id, idSource) => `${configurationPath(id)}/${CONFIGURATION_SOURCES_PATH}/${idSource}`;
export const navigateToConfigurationSourcesShow = (id, idSource) => {
  hashHistory.push(configurationSourcesShowPath(id, idSource));
};
export const configurationDevicesAddPath = (id) => `${configurationPath(id)}/${CONFIGURATION_DEVICES_PATH}/add`;
export const navigateToConfigurationDevicesAdd = (id) => {
  hashHistory.push(configurationDevicesAddPath(id));
};
export const configurationDevicesShowPath = (id, idDevice) => `${configurationPath(id)}/${CONFIGURATION_DEVICES_PATH}/${idDevice}`;
export const navigateToConfigurationDevicesShow = (id, idDevice) => {
  hashHistory.push(configurationDevicesShowPath(id, idDevice));
};
export const configurationDevicesReplacePath = (id, idDevice) => `${configurationDevicesShowPath(id, idDevice)}/replace`;
export const navigateToConfigurationDevicesReplace = (id, idDevice) => {
  hashHistory.push(configurationDevicesReplacePath(id, idDevice));
};
export const configurationDeviceSlavesAddPath = (id, idDevice) => `${configurationDevicesShowPath(id, idDevice)}/${CONFIGURATION_DEVICES_SLAVES_PATH}/add`;
export const navigateToConfigurationDeviceSlavesAdd = (id, idDevice) => {
  hashHistory.push(configurationDeviceSlavesAddPath(id, idDevice));
};
export const configurationDeviceSlavesShowPath = (id, idDevice, idSlave) => `${configurationDevicesShowPath(id, idDevice)}/${CONFIGURATION_DEVICES_SLAVES_PATH}/${idSlave}`;
export const navigateToConfigurationDeviceSlavesShow = (id, idDevice, idSlave) => {
  hashHistory.push(configurationDeviceSlavesShowPath(id, idDevice, idSlave));
};
export const configurationDeviceSlavesReplacePath = (id, idDevice, idSlave) => `${configurationDeviceSlavesShowPath(id, idDevice, idSlave)}/replace`;
export const navigateToConfigurationDeviceSlavesReplace = (id, idDevice, idSlave) => {
  hashHistory.push(configurationDeviceSlavesShowPath(id, idDevice, idSlave));
};

// Scenarios
export const scenariosPath = (id) => `${showPath(id)}/${SCENARIOS_PATH}`;
export const navigateToScenarios = (id) => {
  hashHistory.push(scenariosPath(id));
};
export const scenariosAddPath = (id) => `${scenariosPath(id)}/add`;
export const navigateToScenariosAdd = (id) => {
  hashHistory.push(scenariosAddPath(id));
};
export const scenariosShowPath = (id, idScenario) => `${scenariosPath(id)}/${idScenario}`;
export const navigateToScenariosShow = (id, idScenario) => {
  hashHistory.push(scenariosShowPath(id, idScenario));
};

// Customers
export const customersPath = (id) => `${showPath(id)}/${CUSTOMERS_PATH}`;
export const navigateToCustomers = (id) => {
  hashHistory.push(customersPath(id));
};
export const customersAddPath = (id) => `${customersPath(id)}/add`;
export const navigateToCustomersAdd = (id) => {
  hashHistory.push(customersAddPath(id));
};
export const customersShowPath = (id, idCustomer) => `${customersPath(id)}/${idCustomer}`;
export const navigateToCustomersShow = (id, idCustomer) => {
  hashHistory.push(customersShowPath(id, idCustomer));
};

// Plannings
export const planningsPath = (id) => `${showPath(id)}/${PLANNINGS_PATH}`;
export const navigateToPlannings = (id) => {
  hashHistory.push(planningsPath(id));
};
export const planningsAddPath = (id) => `${planningsPath(id)}/add`;
export const navigateToPlanningsAdd = (id) => {
  hashHistory.push(planningsAddPath(id));
};
export const planningsShowPath = (id, idPlanning) => `${planningsPath(id)}/${idPlanning}`;
export const navigateToPlanningsShow = (id, idPlanning) => {
  hashHistory.push(planningsShowPath(id, idPlanning));
};

// Logs
export const logsPath = (id) => `${showPath(id)}/${LOGS_PATH}`;
export const navigateToLogs = (id) => {
  hashHistory.push(logsPath(id));
};

// Async operations
export const asyncOperationsPath = (id) => `${showPath(id)}/${ASYNC_OPERATIONS_PATH}`;
export const navigateToAsyncOperations = (id) => {
  hashHistory.push(asyncOperationsPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/installations/navigation.js